import { Component, OnInit, computed, inject, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { DefaultEmailService } from "@tylertech/core-module";
import { ForgeButtonModule, ForgeCardModule, ForgeToolbarModule } from "@tylertech/forge-angular";
import { AugmentedModelObject, MetadataPanelComponent } from "@tylertech/metadata-module";
import { ClassMetadata } from "@tylertech/tyler-api-types";

@Component({
    selector: "email-test-card",
    imports: [
        ForgeCardModule,
        ForgeButtonModule,
        ForgeToolbarModule,
        FormsModule,
        MetadataPanelComponent,
    ],
    templateUrl: "./emailTestCard.tmpl.html",
})
export class EmailTestCardComponent implements OnInit
{
    private $defaultEmailService = inject(DefaultEmailService);

    readonly metadata = signal<ClassMetadata | undefined>(undefined);
    readonly model = signal<AugmentedModelObject | undefined>(undefined);

    readonly loaded = computed(() =>
    {
        return this.metadata() !== undefined;
    });

    readonly running = signal(false);

    ngOnInit(): void
    {
        this.$defaultEmailService.ShowEmailTest()
            .then(x =>
            {
                if (!x)
                {
                    return;
                }

                return Promise.all(
                    [
                        this.$defaultEmailService.GetEmailTestMetadata()
                            .then(x =>
                            {
                                this.metadata.set(x);
                            }),
                        this.$defaultEmailService.GetEmailTestInfo()
                            .then(x =>
                            {
                                this.model.set(x);
                            })
                    ]);
            });
    }

    test(): void
    {
        this.running.set(true);
        this.$defaultEmailService.EmailTest()
            .then(x =>
            {
                this.model.set(x);
            })
            .finally(() =>
            {
                this.running.set(false);
            });
    }
}
